import React from 'react'
import { CartsTable } from '../components/carts-table';

export const CartsPage: React.FC = () => <CartsTable />;
